import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";

const items = [
  { to: "/", label: "HOME", end: true, testid: "hq-drawer-home" },
  { to: "/songs", label: "SONGS", testid: "hq-drawer-songs" },
  { to: "/beats", label: "BEATS", testid: "hq-drawer-beats" },
  { to: "/wrld", label: "LXNWRLD", testid: "hq-drawer-wrld" },
  { to: "/projects", label: "PROJECTS", testid: "hq-drawer-projects" },
  { to: "/catalog", label: "CATALOG", testid: "hq-drawer-catalog" },
  { to: "/more", label: "MORE", testid: "hq-drawer-more", also: ["/releases", "/statistics", "/archive", "/account", "/settings"] },
];

function HqDrawer({ open, onClose }) {
  const { pathname } = useLocation();
  return (
    <>
      <div onClick={onClose} aria-hidden="true" data-testid="hq-drawer-backdrop"
        className={`md:hidden fixed inset-0 z-[60] bg-black/60 backdrop-blur-sm transition-opacity ${open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"}`} />
      <aside data-testid="hq-drawer" aria-hidden={open ? "false" : "true"}
        className={`md:hidden fixed top-0 bottom-0 left-0 z-[61] w-72 max-w-[85vw] bg-[#050506] border-r border-white/5 transition-transform duration-300 ease-out ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="h-full flex flex-col" style={{ paddingTop: "calc(env(safe-area-inset-top, 0px) + 0.5rem)", paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 1rem)" }}>
          <div className="flex items-center justify-between px-5 py-4">
            <span className="text-[15px] leading-none tracking-[0.42em] font-light text-white/90 select-none">LXN HQ</span>
            <button onClick={onClose} data-testid="hq-drawer-close" aria-label="Close menu"
              className="w-9 h-9 rounded-full bg-white/5 hover:bg-white/10 flex items-center justify-center">
              <X className="w-4 h-4" />
            </button>
          </div>
          <nav className="flex-1 min-h-0 overflow-y-auto overscroll-contain mt-2 px-3" data-testid="hq-drawer-nav">
            {items.map((it) => (
              <NavLink key={it.to} to={it.to} end={it.end} onClick={onClose} data-testid={it.testid}
                className={({ isActive }) => `w-full px-4 py-4 rounded-xl flex items-center justify-between transition-colors ${(isActive || it.also?.includes(pathname)) ? "bg-white/[0.06] text-white" : "text-zinc-400 hover:bg-white/[0.03] hover:text-white"}`}>
                <span className="text-[11px] tracking-[0.4em] font-medium">{it.label}</span>
                <ChevronRight className="w-4 h-4 opacity-40" />
              </NavLink>
            ))}
          </nav>
          <div className="px-5 py-4 text-[9px] tracking-[0.5em] text-zinc-700 uppercase mono" data-testid="hq-drawer-est">EST. 2026</div>
        </div>
      </aside>
    </>
  );
}

export function MobileHeader({ hidden }) {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setOpen(false); }, [pathname]);
  return (
    <>
      <header data-testid="hq-mobile-header"
        className={`md:hidden fixed top-0 left-0 right-0 z-40 px-5 flex items-center bg-[#0A0A0C]/85 backdrop-blur-md border-b border-white/5 transition-opacity ${hidden ? "opacity-0 pointer-events-none" : "opacity-100"}`}
        style={{ height: "calc(44px + env(safe-area-inset-top, 0px))", paddingTop: "env(safe-area-inset-top, 0px)" }}>
        <button onClick={() => setOpen(true)} data-testid="hq-menu-btn" aria-label="Open menu"
          className="relative z-10 w-9 h-9 -ml-2 rounded-lg hover:bg-white/5 flex items-center justify-center">
          <Menu className="w-5 h-5" />
        </button>
        <div className="pointer-events-none absolute inset-x-0 flex items-center justify-center" style={{ top: "env(safe-area-inset-top, 0px)", bottom: 0 }}>
          <span data-testid="hq-header-brand" className="select-none text-white/95"
            style={{ fontFamily: "'Manrope', system-ui, sans-serif", fontWeight: 300, fontSize: "15px", letterSpacing: "0.55em", paddingLeft: "0.55em" }}>
            LXN HQ
          </span>
        </div>
      </header>
      <HqDrawer open={open} onClose={() => setOpen(false)} />
    </>
  );
}
